import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Eye } from "lucide-react";
import { Badge } from "../../base/badge/badge";
import { ACTION_TYPE_ICONS } from "./stepFieldIcons";
/**
 * Compact step card used in step lists/tables: action-type icon, step name and
 * an optional eye button opening a detail preview.
 */ export function StepDescriptionCell({ actionType, generatedName, taskDescription, ruleCount = 0, isIncomplete, onPreviewClick }) {
    const { t } = useTranslation();
    const isDecision = actionType === "decision";
    const getDescription = ()=>{
        // Priority 1: AI-generated name
        if (generatedName) return generatedName;
        // Priority 2: Decision with rule count
        if (isDecision) {
            return ruleCount > 0 ? t("processes.decisionWithRules", {
                count: ruleCount
            }) : t("processes.decision");
        }
        // Priority 3: Task description
        return taskDescription || "";
    };
    const description = getDescription();
    if (!description) return /*#__PURE__*/ _jsx("span", {
        className: "text-sm text-gray-8",
        children: "-"
    });
    const Icon = ACTION_TYPE_ICONS[actionType];
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-3 border border-border-11 rounded-lg p-2 max-w-md",
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                className: `h-4 w-4 shrink-0 ${isDecision ? "text-highlight" : "text-info"}`
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex-1 min-w-0 space-y-1",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-sm font-normal text-black truncate",
                        children: description
                    }),
                    isIncomplete && /*#__PURE__*/ _jsx(Badge, {
                        variant: "outline",
                        className: "text-xs",
                        children: t("processes.incompleteStep")
                    })
                ]
            }),
            onPreviewClick && /*#__PURE__*/ _jsx("button", {
                onClick: onPreviewClick,
                "aria-label": description,
                className: "flex items-center justify-center w-8 h-8 rounded-lg border border-border-11 hover:bg-surface-subtle shrink-0",
                children: /*#__PURE__*/ _jsx(Eye, {
                    className: "h-4 w-4 text-[#636369]"
                })
            })
        ]
    });
}

//# sourceMappingURL=StepDescriptionCell.js.map